import React from 'react';
import { ExternalLink } from 'lucide-react';
import { portfolioItems } from '../data/mock';

const Portfolio = () => {
  return (
    <section id="portfolio" className="portfolio-section">
      <div className="section-container">
        <div className="section-header-center">
          <h2 className="section-title-large">Portfolio</h2>
          <p className="section-subtitle">
            Proyectos reales que hemos desarrollado para nuestros clientes
          </p>
        </div>

        <div className="portfolio-grid">
          {portfolioItems.map((item) => (
            <div key={item.id} className="portfolio-card">
              <a 
                href={item.url} 
                target="_blank" 
                rel="noopener noreferrer"
                className="portfolio-mockup-link"
              >
                <div className="portfolio-mockup-real">
                  {/* Desktop Preview */}
                  <div className="mockup-desktop-real">
                    <div className="mockup-screen-real">
                      <img 
                        src={item.desktopImage} 
                        alt={`${item.title} - Vista Desktop`}
                        className="mockup-image"
                      />
                    </div>
                  </div>

                  {/* Mobile Preview */}
                  <div className="mockup-mobile-real">
                    <div className="mockup-mobile-screen-real">
                      <img 
                        src={item.mobileImage} 
                        alt={`${item.title} - Vista Mobile`}
                        className="mockup-image"
                      />
                    </div>
                  </div>

                  <div className="portfolio-overlay">
                    <ExternalLink size={32} className="external-link-icon" />
                    <span className="overlay-text">Ver sitio web</span>
                  </div>
                </div>
              </a>

              <div className="portfolio-info">
                <span className="portfolio-category">{item.category}</span>
                <h3 className="portfolio-title">{item.title}</h3>
                <p className="portfolio-description">{item.description}</p>
                {item.isDemo && (
                  <span className="portfolio-demo-badge">Proyecto Demo</span>
                )}
                {!item.isDemo && (
                  <span className="portfolio-real-badge">Proyecto Real</span>
                )}
                <a 
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="portfolio-link"
                >
                  Visitar sitio web
                  <ExternalLink size={16} />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
